// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"StocksFilterSelect_chromeframe__CCILz","select":"StocksFilterSelect_select__35--6"};